import React from 'react'
import {PageWrap} from "../../Components";
import VacationRequestForm from "../../Containers/Vacation/VacationRequestForm";

const VacationRequestCreatePage = () => (
    <PageWrap>
        <h3>휴가신청서 작성</h3>
        <VacationRequestForm/>
    </PageWrap>
)

export default VacationRequestCreatePage
